import React, { useEffect, useState } from 'react';
import { useAuth } from 'oidc-react';
import { Container } from '@mui/material';
import useAuthenticated from 'core/data/authenticated';
import styled from 'theme/styled';
import { makeRequest } from 'core/user/request-helper';

export default function Callback(): JSX.Element {
  const [, setAuthenticated] = useAuthenticated();
  const [showMessage, setShowMessage] = useState(false);
  const { isLoading } = useAuth();

  useEffect(() => {
    setTimeout(() => {
      setShowMessage(true);
    }, 1000);
  }, []);

  useEffect(() => {
    const exchangeToken = async () => {
      // exchange the auth token for a Komp pro cookie
      const res = await makeRequest('/token', {}, 'POST');
      if (res.status === 200) {
        setAuthenticated('authenticated');
        const path = window.localStorage.getItem('location');
        window.open(path || '/app/manage', '_self');
      }
    };
    if (!isLoading) exchangeToken();
  }, [isLoading]);

  if (showMessage) {
    return (
      <Wrapper>
        <Container>
          <section>
            <p>This page should forward you to Komp Pro</p>
            <a href='/app/manage/'>
              If it for some reason does not you can click here
            </a>
          </section>
        </Container>
      </Wrapper>
    );
  }

  return (
    // an empty page that that is used to when redirecting to and from our authentication service
    <p>&nbsp;</p>
  );
}

const Wrapper = styled.div`
  display: grid;
  justify-content: center;
  section {
    margin-top: 10em;
  }
`;
